module.exports = __webpack_public_path__ + "assets/creditaccord.ab47c792.svg";